<template>
  <div>
    <h5 class="content-block">Komparasi Gaji</h5>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="editors-container">
          <div class="col">
            <dt class="col-sm-4">Import file excel data gaji pegawai</dt>
            <dt class="col-sm-8">
              <input type="file" ref="fileInput" @change="handleFile" />
            </dt>
          </div>
        </div>
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Gaji</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="pegawaiIdentifierSource"
                valueExpr="val"
                displayExpr="nama"
                width="100%"
                label="Status Pegawai"
                placeholder="Status Pegawai"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.pegawaiIdentifier"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="compare()"
                text="COMPARE EXCEL TO SYSTEM"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="compareTwoWay()"
                text="COMPARE SYSTEM TO EXCEL"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSourceFileExcel"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="nik"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @editing-start="editingStart"
          @option-changed="onPageChanged($event, 'dataGrid')"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />

          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <!-- <DxColumn type="buttons" :fixed="true" fixed-position="right">
            <DxButtonDatagrid name="edit" />
            <DxButtonDatagrid
              hint="Detail Pegawai"
              icon="search"
              :visible="true"
              @click="detailPegawai"
            />
          </DxColumn> -->

          <DxToolbar> </DxToolbar>

          <DxColumnFixing :enabled="true" />
          <DxColumn
            caption="#"
            data-field="nik"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :fixed="true"
            fixed-position="left"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-field="nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
          />
          <DxColumn
            data-field="nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
          />
          <DxColumn data-field="golongan" caption="Gol" :fixed="true" />

          <DxColumn
            data-field="status_ptkp"
            caption="Status PTKP"
            :fixed="true"
          />
          <DxColumn
            data-field="gaji_pokok"
            caption="gaji_pokok"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_perusahaan"
            caption="tun_perusahaan"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_jabatan"
            caption="tun_jabatan"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_air"
            caption="tun_air"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_transport"
            caption="tun_transport"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_pangan"
            caption="tun_pangan"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_kesehatan"
            caption="tun_kesehatan"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="premi_jkk"
            caption="premi_jkk"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="premi_jkm"
            caption="premi_jkm"
            cell-template="currencyTemplate"
          />

          <DxColumn data-field="jml_tdk_hadir" caption="jml_tdk_hadir" />
          <DxColumn
            data-field="pot_5_persen"
            caption="pot_5_persen"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="jml_bruto"
            caption="jml_bruto"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="tun_pph"
            caption="tun_pph"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_kesehatan"
            caption="pot_kesehatan"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_bpjs_tk_tiga_program"
            caption="pot_bpjs_tk_tiga_program"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_bpjs_tk_empat_program"
            caption="pot_bpjs_tk_empat_program"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_pensiun"
            caption="pot_pensiun"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_pph"
            caption="pot_pph"
            cell-template="currencyTemplate"
          />

          <DxColumn
            data-field="honor_umk_jml"
            caption="honor_umk_jml"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="kenaikan_masa_kerja"
            caption="kenaikan_masa_kerja"
            cell-template="currencyTemplate"
          />

          <DxColumn
            data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
            caption="tun_bpjs_tk_satu_sembilanbelas_persen"
            cell-template="currencyTemplate"
          />

          <DxColumn
            data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
            caption="pot_bpjs_tk_satu_sembilanbelas_persen"
            cell-template="currencyTemplate"
          />
          <DxColumn
            data-field="pot_bpjs_tk_dua_persen"
            caption="pot_bpjs_tk_dua_persen"
            cell-template="currencyTemplate"
          />

          <DxColumn
            data-field="total_diterima"
            caption="total_diterima"
            cell-template="currencyTemplate"
          />
          <template #currencyTemplate="{ data }">
            {{ formatNumber(data.value) }}
          </template>
        </DxDataGrid>
      </div>
    </div>

    <div class="content-block">
      <ul>
        <li v-for="item in compareItem" :key="item.id">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import { DateTime } from "luxon";
import _ from "lodash";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import notify from "devextreme/ui/notify";
// import ODataStore from "devextreme/data/odata/store";
// import DataSource from "devextreme/data/data_source";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxColumnFixing,
  DxToolbar,
  // DxButton as DxButtonDatagrid,
  // DxSummary,
  // DxTotalItem,
  // DxItem,
} from "devextreme-vue/data-grid";

import * as XLSX from "xlsx";

const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];
const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [Number(currentYear) - 1, currentYear, Number(currentYear) + 1];
export default {
  components: {
    DxButton,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxColumnFixing,
    DxToolbar,
    // DxButtonDatagrid,
    DxSelectBox,
  },
  data() {
    return {
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      filters: {
        bulan: Number(currentMonth),
        tahun: Number(currentYear),
        pegawaiIdentifier: "nik",
      },
      pegawaiIdentifierSource: [
        { val: "nik", nama: "Direksi/Tetap/Capeg" },
        { val: "nama", nama: "Honor/Kontrak" },
      ],

      bulanSource: months,
      tahunSource: years,

      file: null,

      dataSource: null,
      dataSourceFileExcel: null,
      numberingPageSize: 10,
      numberingPageNumber: 0,
      compareItem: null,
    };
  },
  mounted() {},
  methods: {
    async compare() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        data: this.dataSourceFileExcel,
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        pegawaiIdentifier: this.filters.pegawaiIdentifier,
      };

      await axios
        .post(`${API_BASE_URL}/compare_gaji_import_excel`, data, config)
        .then((response) => {
          notify("Berhasil compare", "success");
          this.compareItem = response.data;
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal compare", "error");
        });
    },

    async compareTwoWay() {
      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: api.defaults.headers.common["Authorization"],
        },
      };
      var data = {
        data: this.dataSourceFileExcel,
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        pegawaiIdentifier: this.filters.pegawaiIdentifier,
      };

      await axios
        .post(
          `${API_BASE_URL}/compare_gaji_import_excel_from_system_to_excel`,
          data,
          config
        )
        .then((response) => {
          notify("Berhasil compare", "success");
          this.compareItem = response.data;
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal compare", "error");
        });
    },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    roundToInteger(val) {
      if (isNaN(val)) return 0;

      return Math.round(val);
    },

    async handleFile(e) {
      const files = e.target.files;
      const file = files[0];
      this.file = file;
      const self = this;
      const reader = new FileReader();
      const dataSourceTemp = [];
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        this.data = XLSX.utils.sheet_to_json(worksheet, {});
        self.dataSource = this.data;
        const searchString = "NIK.";

        const occurrences = [];

        // Iterate through the multi-dimensional array
        if (this.filters.pegawaiIdentifier === "nik") {
          //direksi/tetap/capeg
          _.forEach(this.data, (row, rowIndex) => {
            _.forEach(row, (value, colIndex) => {
              if (_.isString(value) && value.includes(searchString)) {
                var temp = {};
                temp.nik = value.toLowerCase().replace("nik.", "").trim();
                temp.nik = temp.nik.replace("nik", "").trim();
                temp.nama = this.data[rowIndex - 1].nama;
                temp.golongan = this.data[rowIndex - 1].golongan;
                temp.status_ptkp = this.data[rowIndex - 1].status_ptkp;
                temp.gaji_pokok = self.roundToInteger(
                  this.data[rowIndex - 1].gaji_pokok
                );
                temp.tun_perusahaan = self.roundToInteger(
                  this.data[rowIndex - 1].tun_perusahaan
                );
                temp.tun_jabatan = self.roundToInteger(
                  this.data[rowIndex - 1].tun_jabatan
                );
                temp.tun_air = self.roundToInteger(
                  this.data[rowIndex - 1].tun_air
                );
                temp.tun_transport = self.roundToInteger(
                  this.data[rowIndex - 1].tun_transport
                );
                temp.tun_pangan = self.roundToInteger(
                  this.data[rowIndex - 1].tun_pangan
                );
                temp.tun_kesehatan = self.roundToInteger(
                  this.data[rowIndex - 1].tun_kesehatan
                );
                temp.premi_jkm = self.roundToInteger(
                  this.data[rowIndex - 1].premi_jkm
                );
                temp.premi_jkk = self.roundToInteger(
                  this.data[rowIndex - 1].premi_jkk
                );
                temp.jml_tdk_hadir = self.roundToInteger(
                  this.data[rowIndex - 1].jml_tdk_hadir
                );
                temp.pot_5_persen = self.roundToInteger(
                  this.data[rowIndex - 1].pot_5_persen
                );
                temp.jml_bruto = self.roundToInteger(
                  this.data[rowIndex - 1].jml_bruto
                );
                temp.tun_pph = self.roundToInteger(
                  this.data[rowIndex - 1].tun_pph
                );
                temp.pot_kesehatan = self.roundToInteger(
                  this.data[rowIndex - 1].pot_kesehatan
                );
                temp.pot_bpjs_tk_tiga_program = self.roundToInteger(
                  this.data[rowIndex - 1].pot_bpjs_tk_tiga_program
                );
                temp.pot_bpjs_tk_empat_program = self.roundToInteger(
                  this.data[rowIndex - 1].pot_bpjs_tk_empat_program
                );
                temp.pot_pensiun = self.roundToInteger(
                  this.data[rowIndex - 1].pot_pensiun
                );
                temp.pot_pph = self.roundToInteger(
                  this.data[rowIndex - 1].pot_pph
                );

                temp.total_diterima = self.roundToInteger(
                  this.data[rowIndex - 1].total_diterima
                );

                // self.dataSourceFileExcel.push(temp);
                dataSourceTemp.push(temp);

                occurrences.push({
                  value: value.replace("NIK.", "").trim(),
                  row: rowIndex,
                  column: colIndex,
                });
              }
            });
          });
        } //akhir pegawaiIdentifier ===nik / direksi/tetap/capeg
        else {
          _.forEach(this.data, (row) => {
            // _.forEach(row, (value, colIndex) => {
            var temp = {};
            temp.nama = row.nama;
            temp.golongan = row.golongan;
            temp.status_ptkp = "";
            temp.honor_umk_jml = self.roundToInteger(row.honor_umk_jml);
            temp.kenaikan_masa_kerja = self.roundToInteger(
              row.kenaikan_masa_kerja
            );
            temp.tun_kesehatan = self.roundToInteger(row.tun_kesehatan);
            temp.premi_jkm = self.roundToInteger(row.premi_jkm);
            temp.premi_jkk = self.roundToInteger(row.premi_jkk);
            temp.jml_tdk_hadir = self.roundToInteger(row.jml_tdk_hadir);
            temp.pot_5_persen = self.roundToInteger(row.pot_5_persen);
            temp.jml_bruto = self.roundToInteger(row.jml_bruto);
            temp.pot_kesehatan = self.roundToInteger(row.pot_kesehatan);
            temp.pot_bpjs_tk_dua_persen = self.roundToInteger(
              row.pot_bpjs_tk_dua_persen
            );
            temp.total_diterima = self.roundToInteger(row.total_diterima);

            dataSourceTemp.push(temp);

            // });
          });
        } //akhir else

        self.dataSourceFileExcel = dataSourceTemp;
      };

      reader.readAsBinaryString(file);
    },

    getNikFromExcel(val) {
      val = val.toLowerCase();
      let nik = val.replace("nik.", "").trim();
      nik = nik.replace("nik", "").trim();
      return nik;
    },
  },
};
</script>
